<!-- eslint-disable vue/valid-v-slot -->
<template>
  <component
    v-if="isAvailable && !renderData.skipMatch"
    v-bind="getPropsAndSlotContext()"
    v-on="renderData.data.on"
    :ref="`renderData_${renderData.id}`"
    :is="renderData.tag"
    @openEditor="openEditor(renderData)"
    @openChildEditor="openChildEditor(true, $event)"
    @changeChildrenOrder="changeChildrenOrder"
  >
    <template #default="slotContext" v-if="loadSlot && !isHTMLElement">
      <root-matcher
        v-for="(child, index) in renderData.children"
        :key="index"
        :renderData="child"
        :slotContext="slotContext"
        @openEditor="openEditor($event)"
        @openChildEditor="openChildEditor(false, $event)"
        @changeChildrenOrder="changeChildrenOrder"/>
    </template>
    <template v-if="loadSlot && isHTMLElement && (renderData.children instanceof Array)">
      <root-matcher
        v-for="(child, index) in renderData.children"
        :key="index"
        :renderData="child"
        :slotContext="slotContext"
        @openEditor="openEditor($event)"
        @openChildEditor="openChildEditor(false, $event)"
        @changeChildrenOrder="changeChildrenOrder"/>
    </template>
    <template v-else-if="loadSlot && isHTMLElement && renderData.children">
      <template v-for="(slotChildren, slotName) in renderData.children">
        <root-matcher
          v-for="(child, index) in slotChildren"
          v-slot:[slotName]="slotContext"
          :key="slotName + '-' + index"
          :renderData="child"
          :slotContext="slotContext"
          @openEditor="openEditor($event)"
          @openChildEditor="openChildEditor(false, $event)"
          @changeChildrenOrder="changeChildrenOrder"
        />
      </template>
    </template>
  </component>
</template>

<script>
import RenderData from '../RenderData'
import { allRenders, isModuleAvailable } from '../modules'

export default {
  name: 'RootMatcher',
  props: {
    renderData: {
      type: RenderData,
      required: true
    },
    slotContext: {
      default () {
        return undefined
      }
    }
  },
  components: {
    ...allRenders
  },
  data () {
    return {
      loadSlot: false,
      isHTMLElement: true
    }
  },
  computed: {
    isAvailable () {
      return isModuleAvailable(this.renderData)
    }
  },
  created () {

  },
  mounted () {
    this.$parent.addModuleRef && this.$parent.addModuleRef(this.$refs)
    this.isHTMLElement = this.$refs[`renderData_${this.renderData.id}`] instanceof HTMLElement
    this.loadSlot = true
  },
  methods: {
    getPropsAndSlotContext () {
      let props = this.renderData.data.props
      if (!props) {
        props = {}
        this.renderData.data.props = props
      }
      if (props.needChildren) {
        props.children = this.renderData.children
      }
      if (this.slotContext) {
        props.__slotContext__ = this.slotContext
      }
      return props
    },
    openEditor (renderData) {
      this.$emit('openEditor', renderData)
    },
    openChildEditor (isSelf, $event) {
      if ($event.customChildRenderData) {
        this.$emit('openChildEditor', {
          renderData: this.renderData,
          editorName: $event.editorName,
          childRenderData: $event.customChildRenderData
        })
      } else if (isSelf) {
        this.$emit('openChildEditor', {
          renderData: $event.fromChild ? null : this.renderData,
          editorName: $event.editorName,
          childRenderData: $event.fromChild ? this.renderData : null
        })
      } else {
        if (!$event.renderData) {
          $event.renderData = this.renderData
        }
        this.$emit('openChildEditor', $event)
      }
    },
    changeChildrenOrder (data) {
      if (!data.renderData) {
        this.$emit('changeChildrenOrder', { ...data, renderData: this.renderData })
      } else {
        this.$emit('changeChildrenOrder', data)
      }
    },
    addModuleRef (refs) {
      this.$parent.addModuleRef && this.$parent.addModuleRef(refs)
    }
  }
}
</script>
